import { render } from "./wysiwyg.vue?vue&type=template&id=0a8eb106"
import script from "./wysiwyg.vue?vue&type=script&lang=js"
export * from "./wysiwyg.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/form/horizontal/wysiwyg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a8eb106"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a8eb106', __exports__)) {
    console.log('reload')
    api.reload('0a8eb106', __exports__)
  }
  
  module.hot.accept("./wysiwyg.vue?vue&type=template&id=0a8eb106", () => {
    console.log('re-render')
    api.rerender('0a8eb106', render)
  })

}


export default __exports__